import { useProfile } from '@/hooks/useProfile';
import { isDemoEnvironment } from '@/util/demoUtils';
import { fullName } from '@/util/util';
import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { TypeAnimation } from 'react-type-animation';

const ChatGreeting = () => {
  const { t } = useTranslation(['chat']);
  const { profile } = useProfile();
  const name = fullName(profile);
  let firstName = name?.split(' ')[0] || '';
  firstName = isDemoEnvironment() ? 'Demo User' : firstName;
  const theme = useTheme();

  return (
    <Box
      data-testid="chat-greeting"
      sx={{
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        textAlign: 'center',
        justifyContent: 'center',
      }}
    >
      <TypeAnimation
        key={`${t('greetings')}, ${firstName} ${theme.palette.primary.main}!`}
        sequence={[`${t('greetings')}, ${firstName}!`, 1000]}
        wrapper="span"
        speed={25}
        style={{
          color: theme.palette.primary.main,
          textWrap: 'nowrap',
          fontSize: '2.25em',
          alignItems: 'center',
          fontWeight: 'bold',
          fontVariant: 'h4',
          display: 'inline-block',
          fontFamily: 'Roboto, serif',
          width: '100%',
          height: '44px',
          lineHeight: '44.46px',
          letterSpacing: '0.25px',
        }}
        cursor={false}
        repeat={Infinity}
      />
      <Typography
        variant="subtitle1"
        color="textSecondary"
        gutterBottom
        sx={{
          fontVariant: 'h1',
          color: theme.palette.primary.main,
          fontWeight: 'regular',
          width: '178p',
          height: '27px',
          gap: '0px',
          opacity: '0px',
          fontSize: '20px',
          lineHeight: '26.68px',
          textAlign: 'center',
          textUnderlinePosition: 'from-font',
          textDecorationSkipInk: 'none',
        }}
      >
        {t('howCanIHelpYou')}
      </Typography>
    </Box>
  );
};
export default ChatGreeting;
